import contentLimiter from './content-limiter.js';
import './content-limiter.scss';

export default contentLimiter;
